import {
    REQUEST_STATE,

    CORE_GET_ALL_AX_RAW_MAT_REQUEST,
    CORE_GET_ALL_AX_RAW_MAT_SUCCESS,
    CORE_GET_ALL_AX_RAW_MAT_FAILURE,

    CORE_GET_ALL_RAW_MATERIAL_REQUEST,
    CORE_GET_ALL_RAW_MATERIAL_SUCCESS,
    CORE_GET_ALL_RAW_MATERIAL_FAILURE,

    CORE_GET_RAW_MATERIAL_BY_ID_REQUEST,
    CORE_GET_RAW_MATERIAL_BY_ID_SUCCESS,
    CORE_GET_RAW_MATERIAL_BY_ID_FAILURE,

    CORE_GET_ALL_RAW_MAT_REQUEST,
    CORE_GET_ALL_RAW_MAT_SUCCESS,
    CORE_GET_ALL_RAW_MAT_FAILURE,

    CORE_GET_ALL_MULTI_PD_RAW_MATT_REQUEST,
    CORE_GET_ALL_MULTI_PD_RAW_MATT_SUCCESS,
    CORE_GET_ALL_MULTI_PD_RAW_MATT_FAILURE,

    CORE_GET_MULTI_PD_RAW_MATT_REQUEST,
    CORE_GET_MULTI_PD_RAW_MATT_SUCCESS,
    CORE_GET_MULTI_PD_RAW_MATT_FAILURE,

    CORE_GET_MULTI_PD_RAW_MATT_BY_ID_REQUEST,
    CORE_GET_MULTI_PD_RAW_MATT_BY_ID_SUCCESS,
    CORE_GET_MULTI_PD_RAW_MATT_BY_ID_FAILURE,

    CORE_GET_ALL_RM_SUMMARY_RAW_MATT_REQUEST,
    CORE_GET_ALL_RM_SUMMARY_RAW_MATT_SUCCESS,
    CORE_GET_ALL_RM_SUMMARY_RAW_MATT_FAILURE,

    CORE_GET_RM_SUMMARY_RAW_MATT_REQUEST,
    CORE_GET_RM_SUMMARY_RAW_MATT_SUCCESS,
    CORE_GET_RM_SUMMARY_RAW_MATT_FAILURE,

    CORE_GET_RM_SUMMARY_RAW_MATT_BY_ID_REQUEST,
    CORE_GET_RM_SUMMARY_RAW_MATT_BY_ID_SUCCESS,
    CORE_GET_RM_SUMMARY_RAW_MATT_BY_ID_FAILURE,

} from '../types'

const requestState = REQUEST_STATE

export default {
    rawMaterials: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_AX_RAW_MAT_REQUEST:
                return state
            case CORE_GET_ALL_AX_RAW_MAT_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_GET_ALL_AX_RAW_MAT_FAILURE:
                return {}
            default:
                return state
        }
    },
    rawMaterialList: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_RAW_MAT_REQUEST:
                return state
            case CORE_GET_ALL_RAW_MAT_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_GET_ALL_RAW_MAT_FAILURE:
                return {}
            default:
                return state
        }
    },
    changeMaterials: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_RAW_MATERIAL_REQUEST:
                return state
            case CORE_GET_ALL_RAW_MATERIAL_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_GET_ALL_RAW_MATERIAL_FAILURE:
                return {}
            default:
                return state
        }
    },
    changeMaterial: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_RAW_MATERIAL_BY_ID_REQUEST:
                return state
            case CORE_GET_RAW_MATERIAL_BY_ID_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_GET_RAW_MATERIAL_BY_ID_FAILURE:
                return {}
            default:
                return state
        }
    },
    multiPd: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_MULTI_PD_RAW_MATT_REQUEST:
            case CORE_GET_MULTI_PD_RAW_MATT_BY_ID_REQUEST:
                return state
            case CORE_GET_MULTI_PD_RAW_MATT_SUCCESS:
            case CORE_GET_MULTI_PD_RAW_MATT_BY_ID_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_GET_MULTI_PD_RAW_MATT_FAILURE:
            case CORE_GET_MULTI_PD_RAW_MATT_BY_ID_FAILURE:
                return {}
            default:
                return state
        }
    },
    multiPdList: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_MULTI_PD_RAW_MATT_REQUEST:
                return state
            case CORE_GET_ALL_MULTI_PD_RAW_MATT_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && Array.isArray(datas)) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_GET_ALL_MULTI_PD_RAW_MATT_FAILURE:
                return {}
            default:
                return state
        }
    },
    rmSummary: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_RM_SUMMARY_RAW_MATT_REQUEST:
            case CORE_GET_RM_SUMMARY_RAW_MATT_BY_ID_REQUEST:
                return state
            case CORE_GET_RM_SUMMARY_RAW_MATT_SUCCESS:
            case CORE_GET_RM_SUMMARY_RAW_MATT_BY_ID_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_GET_RM_SUMMARY_RAW_MATT_FAILURE:
            case CORE_GET_RM_SUMMARY_RAW_MATT_BY_ID_FAILURE:
                return {}
            default:
                return state
        }
    },
    rmSummaryList: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_RM_SUMMARY_RAW_MATT_REQUEST:
                return state
            case CORE_GET_ALL_RM_SUMMARY_RAW_MATT_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && Array.isArray(datas)) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_GET_ALL_RM_SUMMARY_RAW_MATT_FAILURE:
                return {}
            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/rawMaterial.js